import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3e7c72a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 mt-4 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Snabbtåg:"),
    /*#__PURE__*/_createTextVNode(" Frecciarossa, Frecciargento, Frecciabianca ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Privata operatörer:"),
    /*#__PURE__*/_createTextVNode(" Italo")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Regionaltåg:"),
    /*#__PURE__*/_createTextVNode(" Trenitalia Regionale")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Resebokning:"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.trenitalia.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "trenitalia.com"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.italotreno.it",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "italotreno.it")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Bästa tiden att tågluffa:"),
    /*#__PURE__*/_createTextVNode(" Vår och höst – sommar kan bli varmt och trångt. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Budget:"),
    /*#__PURE__*/_createTextVNode(" Mat är ofta prisvärd, men boende i storstäder kostar. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Säkerhet:"),
    /*#__PURE__*/_createTextVNode(" Generellt tryggt, men håll koll på ficktjuvar i storstäder. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Språk:"),
    /*#__PURE__*/_createTextVNode(" Engelska funkar ofta i turistområden, annars några ord italienska gör stor skillnad! ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.interrail.eu/en/plan-your-trip/trip-ideas/italy",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Interrail.eu – Italien")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.trenitalia.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Trenitalia")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.italotreno.it",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Italo")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.rome2rio.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Rome2Rio")
  ])
], -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomPic from "../../generics/CustomPic.vue";
import meta from "@/data/meta.json";
import GridCard from "../GridCard.vue";
import ListCard from "../ListCard.vue";
import Breadcrumbs from "@/components/generics/BreadCrumbs.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ItalyGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).italyGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Italien",
      maxHeight: "60vh",
      backgroundImageClass: "background-italy"
    }),
    _createVNode(ContentWrapper, { showBreadcrumbs: true }, {
      default: _withCtx(() => [
        _createVNode(Breadcrumbs),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, { header: "Upptäck Italien med tåg" }, {
            default: _withCtx(() => [
              _createTextVNode(" Italien är ett drömland för tågluffare. Från de snöklädda Alperna i norr till de solvarma stränderna i söder går tågen som pärlband genom landskap, historia och matkultur. Här kan du enkelt resa mellan klassiska städer som Rom, Florens och Venedig – men också hitta dolda pärlor längs kust och landsbygd. ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Att resa med tåg i Italien" }, {
            default: _withCtx(() => [
              _createTextVNode(" Italien har ett omfattande och relativt prisvärt tågnät. Snabbtågen Frecciarossa och Italo förbinder storstäderna medan regionaltågen når även mindre orter. Interrailkort gäller på de flesta linjer, men snabb- och nattåg kräver ofta platsreservation. "),
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(ListCard, {
            title: "Förslag på tågrutter i Italien",
            items: [
					{
						title: 'Klassiska Italien-rutten',
						description: 'Rom → Florens → Venedig → Milano',
						link: '',
					},
					{
						title: 'Italienska Rivieran',
						description: 'Genua → Cinque Terre → La Spezia',
						link: '',
					},
					{
						title: 'Sydlig upptäcktsfärd',
						description: 'Neapel → Salerno → Cosenza → Sicilien',
						link: '',
					},
					{
						title: 'Alpina äventyr',
						description: 'Bolzano → Trento → Bergamo → Como',
						link: '',
					},
				]
          }),
          _createVNode(GridCard, {
            title: "Destinationer i Italien",
            items: [
					{
						title: 'Rom – historia och pasta',
						image: '🏛️',
						description:
							'Den eviga staden lockar med ruiner, espresso och livlig piazzastämning.',
						link: '/guider/destinationer/italien/rom',
					},
					{
						title: 'Florens och Toscana',
						image: '🍷',
						description:
							'Renässansens vagga – perfekt för konst, vin och landsbygd.',
						link: '/guider/destinationer/italien/toscana',
					},
					{
						title: 'Cinque Terre',
						image: '🌊',
						description:
							'Fem färgstarka kustbyar med magisk utsikt och badvänlig charm.',
						link: '/guider/destinationer/italien/cinque-terre',
					},
					{
						title: 'Neapel och Amalfikusten',
						image: '🍕',
						description: 'Vesuvius, pizza och dramatiska klippor längs kusten.',
						link: '/guider/destinationer/italien/neapel',
					},
					{
						title: 'Alperna och Dolomiterna',
						image: '⛰️',
						description:
							'Vandra, åk skidor eller ta tåget genom snötäckta dalar.',
						link: '/guider/destinationer/italien/alperna',
					},
					{
						title: 'Puglia',
						description:
							'Utforska syditaliens pärla med vita trullihus, kristallklart vatten och livlig matkultur.',
						image: '🇮🇹',
						link: '/guider/destinationer/italien/puglia',
					},
				]
          }, null, 8, ["items"]),
          _createVNode(TextBlock, { header: "Tips för tågluffare i Italien" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Resurser" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})